<template>
  <span></span>
</template>
<script lang="ts" setup>
import { watchEffect, onMounted } from "vue";
import { useStore } from "vuex";
import useMerchantPersistState from "@/apps/merchant3/hooks/useMerchantPersistState";

const props = defineProps({
  appId: {
    type: String,
    default: "894331790632986",
  },
  version: {
    type: String,
    default: "v14.0",
  },
});
const store = useStore();

const loadFacebookSDK = () => {
  if (!isFBScriptLoaded()) {
    let fbScript = document.createElement("script");
    fbScript.src = "https://connect.facebook.net/en_US/sdk.js";
    fbScript.id = "__facebooksdk";
    fbScript.async = true;
    fbScript.defer = true;
    fbScript.crossOrigin = "anonymous";
    document.body.appendChild(fbScript);
    initFB(props.appId, props.version);
  }
};

const initFB = (appId, version) => {
  return new Promise(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: appId,
        autoLogAppEvents: true,
        xfbml: true,
        version: version,
        cookie: true,
      });
      window.FB.AppEvents.logPageView();
    };
  });
};

const isFBScriptLoaded = () => {
  let scripts = document.getElementsByTagName("script");
  for (let i = scripts.length; i--; ) {
    if (scripts[i].id === "__facebooksdk") return true;
  }
  return false;
};

onMounted(() => {
  if (!store.state.merchant?.merchant?.country) {
    useMerchantPersistState(() => true);
  }
});

watchEffect(() => {
  loadFacebookSDK();
});
</script>
